import { render, staticRenderFns } from "./AppSection.vue?vue&type=template&id=39b1d920&scoped=true&"
import script from "./AppSection.vue?vue&type=script&lang=js&"
export * from "./AppSection.vue?vue&type=script&lang=js&"
import style0 from "./AppSection.vue?vue&type=style&index=0&id=39b1d920&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1d920",
  null
  
)

export default component.exports